export enum EConfigurationSetting {
    orderEmailFromAddress = 'ORDER_EMAIL_FROM_ADDRESS',
    orderEmailSubjectPrefix = 'ORDER_EMAIL_SUBJECT_PREFIX',
    supportEmailAddress = 'SUPPORT_EMAIL_ADDRESS'
}

export enum ESettingStatus {
    None,
    Saving,
    Success,
    Error
}

export interface ISetting {
    key: string;
    value: string;
    description: string;
    isRequired: boolean;
    status: ESettingStatus;
}

export interface ISettingFromApi {
    key: string;
    value: string | null;
    description: string;
    createdAt: string;
    updatedAt: string;
}

export interface ISettingsApiResponse {
    data: ISettingFromApi[];
    limit: number;
    total: number;
    skip: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/configuration.ts